import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import { SITE_NAME } from '../constants/site';
import { CONTACT } from '../constants/contact';
import { openZohoChat } from '../utils/openZohoChat';
import './Header.css';

const NAV = [
  { href: '/#about', label: 'About' },
  { href: '/#products', label: 'Products' },
  { href: '/#support', label: 'Support' },
  { href: '/#faq', label: 'FAQs' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`dh-header${menuOpen ? ' is-open' : ''}`}>
      <div className="dh-container dh-header__inner">
        <Link to="/" className="dh-logo" onClick={closeMenu}>
          <span className="dh-logo__mark" aria-hidden />
          {SITE_NAME}
        </Link>

        <nav className="dh-header__nav" aria-label="Primary">
          {NAV.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
          <a href={CONTACT.phoneTel} className="dh-header__phone">
            <FaPhoneAlt aria-hidden />
            {CONTACT.phone}
          </a>
          <button type="button" className="dh-header__cta" onClick={openZohoChat}>
            Get Help
          </button>
        </nav>

        <div className="dh-header__mobile-actions">
          <a
            href={CONTACT.phoneTel}
            className="dh-header__chat-mobile"
            aria-label={`Call ${CONTACT.phone}`}
          >
            Call
          </a>
          <button
            type="button"
            className={`dh-header__toggle${menuOpen ? ' is-active' : ''}`}
            aria-expanded={menuOpen}
            aria-controls="dh-mobile-nav"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      <div
        id="dh-mobile-nav"
        className={`dh-header__drawer${menuOpen ? ' is-open' : ''}`}
        hidden={!menuOpen}
      >
        <nav className="dh-header__drawer-nav" aria-label="Mobile">
          {NAV.map((item) => (
            <a key={item.href} href={item.href} onClick={closeMenu}>
              {item.label}
            </a>
          ))}
          <a href={CONTACT.phoneTel} className="dh-btn dh-btn--blue" onClick={closeMenu}>
            <FaPhoneAlt aria-hidden /> Call Now {CONTACT.phone}
          </a>
          <button
            type="button"
            className="dh-btn dh-btn--outline"
            onClick={(e) => {
              closeMenu();
              openZohoChat(e);
            }}
          >
            Live Chat
          </button>
        </nav>
      </div>
    </header>
  );
}
